interface PageHeaderProps {
  title: string
  description?: string
  action?: React.ReactNode
}

export function PageHeader({ title, description, action }: PageHeaderProps) {
  return (
    <div className="flex items-center justify-between mb-6">
      <div>
        <h1 className="text-2xl font-bold text-compumaq-texto">{title}</h1>
        {description && <p className="text-sm text-compumaq-textoSuave mt-1">{description}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  )
}
